import type { FactoryOpts } from 'imask'

export type MaskPreset = 'phone' | 'currency' | 'currencyWithCents' | 'date' | 'ssn' | 'zip' | 'zipPlus4' | 'percentage' | 'latitude' | 'longitude' | 'decimal'

// Note: Some IMask Number options (like 'signed') are valid at runtime but missing from FactoryOpts types
export const maskPresets: Record<MaskPreset, FactoryOpts> = {
  phone: {
    mask: '(000) 000-0000',
  },
  currency: {
    mask: Number,
    scale: 0,
    thousandsSeparator: ',',
    min: 0,
  },
  currencyWithCents: {
    mask: Number,
    scale: 2,
    thousandsSeparator: ',',
    radix: '.',
    mapToRadix: ['.'],
    min: 0,
    normalizeZeros: true,
    padFractionalZeros: true,
  },
  date: {
    mask: '00/00/0000',
    // Note: For more advanced date validation, use IMask's Date mask
  },
  ssn: {
    mask: '000-00-0000',
  },
  zip: {
    mask: '00000',
  },
  zipPlus4: {
    mask: '00000-0000',
  },
  percentage: {
    mask: Number,
    scale: 2,
    min: 0,
    max: 100,
    radix: '.',
    mapToRadix: ['.'],
  },
  latitude: {
    mask: Number,
    scale: 5,
    signed: true, // allows negative numbers
    min: -90,
    max: 90,
    radix: '.',
    mapToRadix: ['.'],
  } as FactoryOpts,
  longitude: {
    mask: Number,
    scale: 5,
    signed: true, // allows negative numbers
    min: -180,
    max: 180,
    radix: '.',
    mapToRadix: ['.'],
  } as FactoryOpts,
  decimal: {
    mask: Number,
    scale: 2,
    min: 0,
    radix: '.',
    mapToRadix: ['.'],
  },
}
